import {getYearFromTimestamp} from "../../../util/time";

export class Statistics {
    constructor(
        totalJumpsCount,
        jumpsInCurrentYear,
        freefallTime,
        favoriteDropzone,
        favoriteAircraft,
        favoriteCanopy,
        lastJumpedText
    ) {
        this.totalJumpsCount = totalJumpsCount;
        this.jumpsInCurrentYear = jumpsInCurrentYear;
        this.freefallTime = freefallTime;
        this.favoriteDropzone = favoriteDropzone;
        this.favoriteAircraft = favoriteAircraft;
        this.favoriteCanopy = favoriteCanopy;
        this.lastJumpedText = lastJumpedText;
    }
}

function jumpsInCurrentYear(jumps) {
    let currentYear = new Date().getFullYear();
    return jumps.reduce((accumulator, jump) => {
        return currentYear === getYearFromTimestamp(jump.date)
            ? accumulator + 1
            : accumulator;
    }, 0);
}

function freefallTime(jumps) {
    let freefallTime = parseFloat(
        jumps.reduce((accumulator, jump) => accumulator + jump.freeFallTime, 0)
    ).toFixed(0);

    return freefallTime < 60
        ? freefallTime + " s"
        : (freefallTime / 60).toFixed(0) + " m";
}

function mostFrequent(jumps, jumpField) {
    let counts = jumps.reduce((accumulator, jump) => {
        accumulator[[`${jump[[`${jumpField}`]]}`]] = (accumulator[[`${jump[[`${jumpField}`]]}`]] || 0) + 1;
        return accumulator;
    }, {});

    let maxCount = Math.max(...Object.values(counts));
    let mostFrequent = Object.keys(counts).filter(k => {
        return counts[k] === maxCount
    });

    // TODO Second most popular, if most popular is null.
    if(mostFrequent[0] !== 'null') {
        return mostFrequent[0]
    } else {
        return null;
    }
}

function favoriteDropzone(jumps) {
    return mostFrequent(jumps, "dropzone");
}

function favoriteAircraft(jumps) {
    return mostFrequent(jumps, "aircraft");
}

function favoriteCanopy(jumps) {
    return mostFrequent(jumps, "canopy");
}

function lastJumpedText(jumps) {
    let profile_days_from_last_jump_never = "Haven't jumped yet";
    let profile_days_from_last_jump_today = "Jumped today";
    let profile_days_from_last_jump_yesterday = "Jumped yesterday";
    let profile_days_from_last_jump = "Last jumped daysFromLastJump days ago";

    if(jumps.length === 0) {
        return profile_days_from_last_jump_never;
    } else {
        let lastJumpTimestamp = jumps.reduce((lastTimestamp, jump) => Math.max(jump.date, lastTimestamp), 0);
        let diffFromToday = new Date().getTime() / 1000 - lastJumpTimestamp;
        let daysFromLastJump = (diffFromToday / (3600 * 24));

        if(daysFromLastJump < 0.5) {
            return profile_days_from_last_jump_today;
        } else if(daysFromLastJump <= 1.5) {
            return profile_days_from_last_jump_yesterday;
        } else {
            return profile_days_from_last_jump.replace("daysFromLastJump", daysFromLastJump.toFixed(0));
        }
    }
}

export function calculateStatistics(jumps) {
    let statistics = new Statistics();
    statistics.totalJumpsCount = jumps.length;
    statistics.jumpsInCurrentYear = jumpsInCurrentYear(jumps);
    statistics.freefallTime = freefallTime(jumps);
    statistics.favoriteDropzone = favoriteDropzone(jumps);
    statistics.favoriteAircraft = favoriteAircraft(jumps);
    statistics.favoriteCanopy = favoriteCanopy(jumps);
    statistics.lastJumpedText = lastJumpedText(jumps);
    return statistics;
}

